import { useEffect } from 'react';

/** Runs only when React actually commits the root. A suspended/unmounted root
 * must leave the independent HTML recovery deadline armed. */
export default function BootReadySignal() {
  useEffect(() => {
    const splash = document.getElementById('vyv-boot-splash');
    if (!splash) return;
    let secondFrame: number | null = null, removal: number | null = null;
    // Keep the original two-frame handoff after the confirmed React commit.
    const firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(() => {
        window.dispatchEvent(new Event('vyv:boot-ready'));
        splash.classList.add('fade');
        removal = window.setTimeout(() => splash.remove(), 320);
      });
    });
    return () => {
      window.cancelAnimationFrame(firstFrame);
      if (secondFrame !== null) window.cancelAnimationFrame(secondFrame);
      if (removal !== null) window.clearTimeout(removal);
    };
  }, []);
  return null;
}
